module.exports = __webpack_public_path__ + "static/media/badpin.3f1b9659.svg";